module.exports = __webpack_public_path__ + "img/email-white.ae39ba66.png";